'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import slick from 'slick-carousel';

export default class ImageGallery extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {

        this.$main = this.$container.find('.js-ig-main-carousel');
        this.$nav = this.$container.find('.js-ig-nav-carousel');
        this.$arrows = this.$container.find('.js-ig-nav-arrows');

        if (!this.$main.length || !this.$nav.length || !this.$arrows.length) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        this.$main.slick({
            swipe: false,
            asNavFor: this.$nav,
            arrows: false,
            lazyLoad: 'ondemand'
        });

        this.$nav.slick({
            asNavFor: this.$main,
            slidesToShow: 4,
            slidesToScroll: 4,
            focusOnSelect: true,
            appendArrows: this.$arrows,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ],
            prevArrow: `<button type="button" class="ig-nav-arrow ig-nav-arrow--prev">
                            <svg class="ig-nav-arrow__icon">
                                <use xlink:href="#icon-arrow-left"></use>
                            </svg>
                        </button>`,
            nextArrow: `<button type="button" class="ig-nav-arrow ig-nav-arrow--next">
                            <svg class="ig-nav-arrow__icon">
                                <use xlink:href="#icon-arrow-right"></use>
                            </svg>
                        </button>`,
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/image-gallery/js/generic.image-gallery.js